import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../login-service';

@Component({
    selector: 'initiatormyaccount-app',
    templateUrl: 'initiatormyaccount.component.html'
})

export class InitiatorMyaccountComponent implements OnInit {

    userData:any=[];
    documentsList:any;
    skillsList:any;
    filteredskillsList:any=[];
    filtereddocList:any=[];
    workList:any;
    filteredworkList:any=[];
    educationList:any;
    filterededucationList:any=[];
    certificateList:any;
    filteredcertificateList:any=[];
    portfolioList:any;
    filteredportfolioList:any=[];
    userID:any;
    addnewwork: boolean=false;
    workIndustry:any;
    workExperience:any;
    workDescription:any;
    change: string;
    constructor(private loginService:LoginService) { }

    ngOnInit() {
        this.userID=localStorage.getItem('1');
        this.change=localStorage.getItem('4')
        this.getLegaldocuments();
        this.getSkillsregion();
        this.getWorkexperience();
        this.getEducation();
        this.getCertification();
        this.getPortfolio();

     }

     getSkillsregion(){
        this.loginService.GetRegionSkills().subscribe(data=>
            {
              data = JSON.parse(data['_body']);
              this.skillsList =JSON.parse(JSON.stringify(data));
              this.filteredskillsList=this.skillsList.filter(x=>x.userid.toString()===this.userID.toString());
            });
     }
     getLegaldocuments(){
        this.loginService.GetLegalDocuments().subscribe(data=>
            {  
              data = JSON.parse(data['_body']);
              this.documentsList =  JSON.parse(JSON.stringify(data));
              this.filtereddocList=this.documentsList.filter(x=>x.userid.toString()===this.userID.toString());
            });
       
     }
     getWorkexperience(){
        this.loginService.GetWorkExperience().subscribe(data=>
            { 
              data = JSON.parse(data['_body']);
              this.workList =data;
              this.filteredworkList=this.workList.filter(x=>x.userid.toString()===this.userID.toString());
            
             
            });
     }
     getEducation(){
        this.loginService.GetEducation().subscribe(data=>
            {
              data = JSON.parse(data['_body']);
              this.educationList =JSON.parse(JSON.stringify(data));
              this.filterededucationList=this.educationList.filter(x=>x.userid.toString()===this.userID.toString());
            });
     }
     getCertification(){
        this.loginService.GetCertification().subscribe(data=>
            {
              data = JSON.parse(data['_body']);
              this.educationList =JSON.parse(JSON.stringify(data));
              this.filteredcertificateList=this.educationList.filter(x=>x.userid.toString()===this.userID.toString());
              this.filteredcertificateList=JSON.parse(JSON.stringify(this.filteredcertificateList));
            });
     }
     getPortfolio(){
        this.loginService.GetPortfolio().subscribe(data=>
            {
              data = JSON.parse(data['_body']);
              this.portfolioList = JSON.parse(JSON.stringify(data));
              this.filteredportfolioList=this.portfolioList.filter(x=>x.userid.toString()===this.userID.toString());
            });
     }
     addWork(){
          this.addnewwork=true;
     }
}
